import { render, staticRenderFns } from "./SidebarEditCompany.vue?vue&type=template&id=406b57f4&scoped=true"
import script from "./SidebarEditCompany.vue?vue&type=script&lang=js"
export * from "./SidebarEditCompany.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditCompany.vue?vue&type=style&index=0&id=406b57f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b57f4",
  null
  
)

export default component.exports